/**
 * Generated by orval v7.9.0 🍺
 * Do not edit manually.
 * Predictions API
 * API documentation for Predictions
 * OpenAPI spec version: 1.24.0
 */

/**
 * Order action
 */
export type AmendOrderDtoAction = (typeof AmendOrderDtoAction)[keyof typeof AmendOrderDtoAction];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AmendOrderDtoAction = {
  buy: 'buy',
  sell: 'sell',
} as const;
